import SimpleCard from '../../SimpleCard';

const bodyHeading = 'No tenants added yet';
const bodyContent = `Keep track of who’s living in your rental, what their lease terms are, and how to reach them.`;

const EmptyTenantsCard = ({ isLoading = false }: { isLoading?: boolean }) => {
  return (
    <SimpleCard
      data-testid="EmptyTenantsCard"
      body={bodyContent}
      bodyHeading={bodyHeading}
      withChevron={false}
      isLoading={isLoading}
    />
  );
};

export default EmptyTenantsCard;
